module.exports = {"320723001":"侍庄街道","320723100":"伊山镇","320723102":"杨集镇","320723103":"燕尾港镇","320723104":"同兴镇","320723105":"四队镇","320723106":"圩丰镇","320723107":"龙苴镇","320723108":"下车镇","320723109":"图河镇","320723110":"东王集镇","320723209":"小伊乡","320723212":"南岗乡","320723401":"五图河农场","320723402":"灌西盐场","320723403":"灌云经济开发区","320723404":"灌云临港产业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320723.json
// module id = 889
// module chunks = 0